export default "__VITE_PUBLIC_ASSET__1353d716__"